import Instancing from './Instancing.vue';

export default Instancing;
